import searchApi from '@/api/search'
import dayjs from 'dayjs'
import { isNullOrWhiteSpace } from '@/common/utils'
import { IllegalArgumentException } from '@/common/errors'
import _ from 'lodash'

const paramsRegex = /\/tag:(?<tag>[^/]*)|\/text:(?<text>[^/]*)|\/createdTime:(?<createdTime>[^/]*)|\/modifiedTime:(?<modifiedTime>[^/]*)/g
const dateRegex = /^\d{8}(,\d{8})?$/

const state = {
  visible: false,
  text: '',
  loading: false,
  searched: false,
  result: {
    totalCount: 0,
    list: [],
    page: 0
  }
}

const getters = {
  visible (state) {
    return state.visible
  },
  loading (state) {
    return state.loading
  },
  text (state) {
    return state.text
  },
  result (state) {
    return state.result
  },
  searched (state) {
    return state.searched
  }
}

const mutations = {
  SET_VISIBLE (state, visible) {
    state.visible = visible
  },
  SET_TEXT (state, text) {
    state.text = text
  },
  SET_LOADING (state, loading) {
    state.loading = loading
  },
  SET_SEARCHED (state, searched) {
    state.searched = searched
  },
  SET_RESULT (state, result) {
    state.result.totalCount = result.totalCount
    state.result.page = result.page
    const newItems = _.differenceWith(result.list, state.result.list, (m, n) => {
      return m.resourceId === n.resourceId
    })
    state.result.list.push(...newItems)
  },
  RESET_RESULT (state) {
    state.result = {
      totalCount: 0,
      page: 0,
      list: []
    }
  }
}

const actions = {
  async search ({ commit, dispatch }, { text, pageSize }) {
    if (isNullOrWhiteSpace(text)) {
      return
    }
    commit('RESET_RESULT')
    commit('SET_TEXT', text)
    await dispatch('load', { text, page: 1, pageSize })
  },
  async load ({ commit, state }, { page, pageSize }) {
    const parameters = {
      page,
      pageSize,
      tag: '',
      text: '',
      createdTime: '',
      modifiedTime: '',
      fuzzy: ''
    }

    const text = state.text
    let allText = true
    for (const match of text.matchAll(paramsRegex)) {
      allText = false
      if (match.groups.tag) {
        parameters.tag = match.groups.tag
      }
      if (match.groups.text) {
        parameters.text = match.groups.text
      }
      if (match.groups.createdTime) {
        const createdTime = match.groups.createdTime
        if (!dateRegex.test(createdTime)) {
          throw new IllegalArgumentException('createdTime', 'createdTime格式应符合:[yyyyMMdd]或[yyyyMMdd,yyyyMMdd]')
        }
        parameters.createdTime = createdTime.split(',').map(n => dayjs(n, 'YYYYMMDD').unix()).join(',')
      }
      if (match.groups.modifiedTime) {
        const modifiedTime = match.groups.modifiedTime
        if (!dateRegex.test(modifiedTime)) {
          throw new IllegalArgumentException('modifiedTime', 'modifiedTime格式应符合:[yyyyMMdd]或[yyyyMMdd,yyyyMMdd]')
        }
        parameters.modifiedTime = modifiedTime.split(',').map(n => dayjs(n, 'YYYYMMDD').unix()).join(',')
      }
    }

    if (allText) {
      parameters.fuzzy = text
    }

    commit('SET_LOADING', true)
    try {
      const result = await searchApi.search(parameters)
      commit('SET_RESULT', result)
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
